/**
 * Used to add polyfills for support with old browsers.
 */
export default defineNuxtPlugin({
  enforce: "pre",
  setup: () => {
    if (!Object.hasOwn) {
      Object.hasOwn = function (obj, property) {
        return Object.prototype.hasOwnProperty.call(obj, property);
      };
    }

    if (!Array.prototype.at) {
      Array.prototype.at = function (index) {
        if (index >= 0) {
          return this[index];
        } else {
          return this[this.length + index];
        }
      };
    }

    if (import.meta.client && !!window) {
      // seems to be a function that is used by the Instagram WebView and causes an error on iOS
      // see: https://developers.facebook.com/community/threads/320013549791141/
      (window as any)._AutofillCallbackHandler =
        (window as any)._AutofillCallbackHandler || function () {};
    }
  },
});
